<template>
<div class="chapter">
<div class="inner_page">
<a id="page_3"></a>
<h1 class="title">Sovereign <em class="italic">of the</em> Seas 1637</h1>
<p class="sub-title">A RECONSTRUCTION OF THE MOST POWERFUL WARSHIP OF ITS DAY</p>
<p class="author">John McKay</p>
<div class="img_container">
<img alt="images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Title.vue?7eb19ed4